import React, { Component } from 'react'
import { signout } from '../services/signin/actions'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'

class Signout extends Component {
  componentWillMount() {
    this.props.signout()
    this.props.history.push('/')
  }
  render() {
    return <noscript />
  }
}

const mapDispatchToProps = { signout }

export default withRouter(connect(null, mapDispatchToProps)(Signout))



// WEBPACK FOOTER //
// ./src/containers/Signout.js